import { connect } from 'react-redux';

export function getTranslated(model, field, currentLanguage) {

    if (!currentLanguage) {
        return model[field];
    }

    if(!model) {
        return "Could not find translation.";
    }

    if (!model.translations) {
        return model[field];
    }

    //when object is empty php returns array
    if (Array.isArray(model.translations)) {
        return model[field];
    }

    const trans = model.translations[field] || {};

    return trans[currentLanguage.id] || model[field];
}

function Translate ({model, field, currentLanguage}) {
    return getTranslated(model, field, currentLanguage);
}

const mapStateToProps = (state) => ({
    currentLanguage: state.translations?.currentLanguage,
});

export default connect(mapStateToProps)(Translate);
